import { InputHTMLAttributes, forwardRef, ReactNode } from 'react';
import { Search as SearchIcon } from 'lucide-react';

export type SearchSize = 'sm' | 'md' | 'hero';

export interface SearchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  size?: SearchSize;
  hint?: ReactNode;
  width?: number | string;
}

export const Search = forwardRef<HTMLInputElement, SearchProps>(function Search(
  { size = 'md', hint, width, className = '', ...rest },
  ref,
) {
  const classes = [
    'ds-search',
    size === 'sm' ? 'ds-search-sm' : '',
    size === 'hero' ? 'ds-search-hero' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const style: React.CSSProperties = {};
  if (width !== undefined) style.width = width;

  return (
    <div className={classes} style={style}>
      <SearchIcon className="ds-search-icon" size={size === 'hero' ? 16 : 14} />
      <input ref={ref} {...rest} />
      {hint ? <span className="ds-search-hint">{hint}</span> : null}
    </div>
  );
});

export default Search;
